exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".excel_button {\n    background: none;\n    border: none;\n    padding: 0;\n    margin: 0;\n    cursor: pointer;\n    outline: none;\n  }", ""]);

// exports
